/**
 * Atomic Component: RequestTag
 * Displays a color-coded request status tag
 */

import React from 'react';
import { useRequestTags } from '../../../hooks/features/requests/useRequestTags';
import './RequestTag.css';

const RequestTag = ({ request, status }) => {
  const { getTagInfo } = useRequestTags();

  const { tag, label, color } = getTagInfo(request, status);

  if (!tag || !label) return null;

  return (
    <span className="request-tag" style={{ backgroundColor: color }}>
      {label}
    </span>
  );
};

export default RequestTag;
